import { API_URL } from "../../../../setup/config/env";

export const saveCalendarSettings = async ({
    notifyByEmail,
    notifyBySMS,
    workingHours,
    paymentConfiguration,
    isSameDayBookingAllowed,
    leadStatus,
    googleConfig,
    outlookConfig,
    calendarProvider,
}) => {
    try {
        const response = await fetch(`${API_URL}/api/calendar/settings`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                notifyByEmail,
                notifyBySMS,
                workingHours,
                paymentConfiguration,
                isSameDayBookingAllowed,
                leadStatus,
                googleConfig,
                outlookConfig,
                calendarProvider,
            }),
        });

        const data = await response.json();

        if (!data.success) {
            throw new Error(data.message || "Failed to save calendar settings");
        }

        return data.data;
    } catch (error) {
        console.error("Error saving calendar settings:", error);
        throw error;
    }
};

export const authenticateGoogleCalendar = async (payload = {}) => {
    try {
        const response = await fetch(`${API_URL}/api/calendar/authenticate`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.message || "Failed to authenticate Google Calendar");
        }
        return data;
    } catch (error) {
        console.error("Error authenticating Google Calendar:", error);
        throw error;
    }
};

export const authenticateOutlookCalendar = async (payload = {}) => {
    try {
        const response = await fetch(`${API_URL}/api/calendar/outlook/authenticate`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.message || "Failed to authenticate Outlook Calendar");
        }
        return data;
    } catch (error) {
        console.error("Error authenticating Outlook Calendar:", error);
        throw error;
    }
};

export const refreshToken = async (payload = {}) => {
    try {
        const response = await fetch(`${API_URL}/api/calendar/refresh`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                ref: "Refresh",
                ...payload
            }),
        });
        const data = await response.json();
        if (data.success) {
            return data
        } else {
            return { message: "Token refresh failed" };
        }
    } catch (error) {
        console.error("Error refreshing token:", error);
        throw error;
    }
};

export const refreshOutlookToken = async (payload = {}) => {
    try {
        const response = await fetch(`${API_URL}/api/calendar/outlook/refresh`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                ref: "Refresh",
                ...payload
            }),
        });
        const data = await response.json();
        if (data.success) {
            return data
        } else {
            return { message: "Outlook token refresh failed" };
        }
    } catch (error) {
        console.error("Error refreshing Outlook token:", error);
        throw error;
    }
};

export const revokeToken = async (payload = {}) => {
    try {
        const response = await fetch(`${API_URL}/api/calendar/revoke`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (data.success) {
            return data
        } else {
            return { message: "Token revoke failed" };
        }
    } catch (error) {
        console.error("Error revoking token:", error);
        throw error;
    }
}

export const revokeOutlookToken = async (payload = {}) => {
    try {
        const response = await fetch(`${API_URL}/api/calendar/outlook/revoke`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (data.success) {
            return data
        } else {
            return { message: "Outlook token revoke failed" };
        }
    } catch (error) {
        console.error("Error revoking Outlook token:", error);
        throw error;
    }
}

export const cancelEvent = async ({ eventId, crmId, appointmentRefId }) => {
    try {
        const response = await fetch(`${API_URL}/api/calendar/cancel`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                eventId,
                crmId,
                appointmentRefId
            }),
        });

        const data = await response.json();

        if (!data) {
            throw new Error(data.message || "Failed to cancel the event");
        }

        return data;
    } catch (error) {
        console.error("Error canceling event:", error);
        throw error;
    }
};

export const resendInvoiceAPI = async ({ crmId, appointmentRefId, forceCreate }) => {
    try {
        const response = await fetch(`${API_URL}/api/calendar/resend-invoice`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ crmId, appointmentRefId, forceCreate }),
        });
        const data = await response.json();
        if (!data.success) {
            throw new Error(data.message || "Failed to resend invoice");
        }
        return data;
    } catch (error) {
        console.error("Error resending invoice:", error);
        throw error;
    }
};

export const retryBookingAPI = async (payload) => {
    try {
        const response = await fetch(`${API_URL}/api/calendar/book-appointment`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (!data.success) {
            throw new Error(data.error || data.message || "Failed to retry booking");
        }

        return data;
    } catch (error) {
        console.error("Error retrying booking:", error);
        throw error;
    }
};
